/**
 * WalterGO Mobile Menu
 * Handles toggle, body scroll lock, ESC key, and link clicks
 */
(function() {
  'use strict';

  const SELECTORS = {
    header: '[data-waltergo-header]',
    toggle: '[data-mobile-menu-toggle]',
    menu: '[data-mobile-menu]',
    link: '[data-mobile-menu-link]'
  };

  const CLASSES = {
    open: 'is-open',
    bodyLocked: 'waltergo-body-locked'
  };

  class MobileMenu {
    constructor() {
      this.header = document.querySelector(SELECTORS.header);
      if (!this.header) return;

      this.toggle = this.header.querySelector(SELECTORS.toggle);
      this.menu = this.header.querySelector(SELECTORS.menu);
      this.links = this.header.querySelectorAll(SELECTORS.link);

      if (!this.toggle || !this.menu) return;

      this.isOpen = false;
      this.bindEvents();
    }

    bindEvents() {
      // Toggle button click
      this.toggle.addEventListener('click', () => this.toggleMenu());

      // Close on link click
      this.links.forEach(link => {
        link.addEventListener('click', () => this.closeMenu());
      });

      // Close on ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.closeMenu();
          this.toggle.focus();
        }
      });

      // Close on click outside
      document.addEventListener('click', (e) => {
        if (this.isOpen && !this.header.contains(e.target)) {
          this.closeMenu();
        }
      });
    }

    toggleMenu() {
      if (this.isOpen) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    }

    openMenu() {
      this.isOpen = true;
      this.menu.classList.add(CLASSES.open);
      this.toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add(CLASSES.bodyLocked);

      // Focus first link for accessibility
      const firstLink = this.menu.querySelector('a');
      if (firstLink) {
        setTimeout(() => firstLink.focus(), 100);
      }
    }

    closeMenu() {
      this.isOpen = false;
      this.menu.classList.remove(CLASSES.open);
      this.toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove(CLASSES.bodyLocked);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new MobileMenu());
  } else {
    new MobileMenu();
  }
})();
